/**
 * View All Pages Two
 *
 * This is the component that displays the
 * rows version of view all pages.
 *
 *
 */

import React, {useEffect, useState} from "react";

import { connect } from "react-redux";
import { Redirect } from "react-router-dom";

import {
  dealjacketActions,
  ingestionActions,
} from "actions";
import { ClassifyDeal } from "components/ingestor/ClassifyDeal";
import { EditDeal } from "components/dealjacket/EditDeal";
import { ScanModal } from "components/dealjacket/ScanModal";
import { AddonManager } from "../dealjacket/AddonManager";
import { SearchResultsCarousel } from "./SearchResultsCarousel";
import { GridView } from "./GridView";
import { ListView } from "./ListView";
import { JacketInfo } from "./JacketInfo";
import { DealJacketNotes } from "../dealjacket/DealJacketNotes";

function ViewAllPages2(props) {
  const { dealjackets, authentication, alert, classifyDealJacket, getDetail } = props;

  const current_jacket = dealjackets.current;

  const [currentJacketPages, setCurrentJacketPages] = useState([current_jacket?.pages]);
  const [currentPageIndex, setCurrentPageIndex] = useState(0);
  const [showCarousel, setShowCarousel] = useState(false);
  const [showClassify, setShowClassify] = useState(false);
  const [showEditName, setShowEditName] = useState(false);
  const [showAddonModal, setShowAddonModal] = useState(false);
  const [showScanModal, setShowScanModal] = useState(false);


  const dealjacket_id = props.match.params.jacket_id;
  const org_id = props.match.params.org_id;
  const view_type = props.match.params.view_type;


  useEffect(() => {
    getDetail(dealjacket_id);
  }, [dealjacket_id, getDetail])


  let jacketInfo;
  if (current_jacket) {
    jacketInfo = 
    {
      "deal_jacket_name": current_jacket?.name,
      "date_added": current_jacket?.date_created,
      "pageCount": current_jacket?.page_count
    }
  }
  
  const setJacketName = (new_name) => {
    current_jacket.deal_jacket_name = new_name;
    jacketInfo.deal_jacket_name = new_name;
  };

  const setGridView = () => {
    let redirectPath = "/org/" + org_id + "/dealjacket/" + dealjacket_id + "/grid";
    return <Redirect to={redirectPath} />;
  };

  const setListView = () => {
    let redirectPath = "/org/" + org_id + "/dealjacket/" + dealjacket_id + "/list";
    return <Redirect to={redirectPath} />;
  };

  const toggleCarousel = () => {
    setShowCarousel(!showCarousel);
  };

  const toggleClassify = () => {
    setShowClassify(!showClassify);
  };

  const toggleEditName = (event) => {
    setShowEditName(!showEditName);
  };

  const toggleAddonModal = (event) => {
    setShowAddonModal(!showAddonModal);
  };

  const toggleScanModal = (event) => {
    setShowScanModal(!showScanModal);
  };

  const handleClassifyClick = (target) => {
    console.log("classify clicked.");
    toggleClassify();
  };

  function handleClassify() {
    classifyDealJacket(dealjacket_id);
  }

  function handleEditName() {}

  const incrementCarousel = (target) => {
    if (currentPageIndex < currentJacketPages?.length - 1) {
      setCurrentPageIndex(currentPageIndex + 1);
    }
    console.log("incrementing carousel");
  };

  const decrementCarousel = (target) => {
    if (currentPageIndex > 0) {
      setCurrentPageIndex(currentPageIndex - 1);
    }
    console.log("decrementing carousel");
  };

  return (
    <>
    {current_jacket && (
    <div>
      {!alert.type && !current_jacket && (
        <div class="promptArea">
          Loading Deal Jacket
          <br />
          {current_jacket.deal_jacket_name}
          <br />
        </div>
      )}
      {!alert.type && current_jacket && (
        <div className="promptArea">
          <JacketInfo
            jacketInfo={jacketInfo}
            toggleEditName={toggleEditName}
            toggleAddonModal={toggleAddonModal}
            toggleScanModal={toggleScanModal}
            authentication={authentication}
            setGridView={setGridView}
            setListView={setListView}
          />
        </div>
      )}
      {
        <div className="refresh">
          {authentication?.user?.org_id === 1 && (
            <button
              className="classificationIcon"
              onClick={handleClassifyClick}
            >
              Classify
            </button>
          )}
        </div>
      }

      <div
        className={
          showCarousel || showClassify ? "searchMain noScroll" : "searchMain"
        }
      >
        <div className="twoColRightSidebarWrap">
        {view_type ==="grid" && (
          <>
            <GridView
              jacketInfo={jacketInfo}
              dealjacket={current_jacket.pages}
              deal_jacket_id = {dealjacket_id}
              toggleCarousel={toggleCarousel}
              setCurrentPageIndex={setCurrentPageIndex}
              setCurrentJacketPages={setCurrentJacketPages}
            />
            <DealJacketNotes
                org_id={org_id}
                deal_jacket_id = {dealjacket_id}
            />
          </>
        )}
        {view_type === "list" && (
          <>
            <ListView
              jacketInfo={jacketInfo}
              dealjacket={current_jacket.pages}
              deal_jacket_id = {dealjacket_id}
              toggleCarousel={toggleCarousel}
              setCurrentPageIndex={setCurrentPageIndex}
              setCurrentJacketPages={setCurrentJacketPages}
            />
            <DealJacketNotes
                org_id={org_id}
                deal_jacket_id = {dealjacket_id}
            />
          </>
          )}
          </div>
      </div>
      <div
        className="carouselWrapper"
        style={{ visibility: showCarousel ? "visible" : "hidden" }}
      >
        <div className="closeCarousel" onClick={toggleCarousel}>
          X
        </div>
        <SearchResultsCarousel
          key={currentPageIndex}
          images={current_jacket.pages}
          currentImage={currentPageIndex}
          deal_jacket_name={current_jacket.name}
        />
        <div className="carouselFooter">
          {currentPageIndex === 0 && (
            <div className="carouselBack">
              <span
                className="carouselArrowInactive"
                onClick={decrementCarousel}
              >
                back
              </span>
            </div>
          )}
          {currentPageIndex > 0 && (
            <div className="carouselBack">
              <span className="carouselArrow" onClick={decrementCarousel}>
                back
              </span>
            </div>
          )}
          {currentPageIndex < currentJacketPages.length - 1 && (
            <div className="carouselNext">
              <span className="carouselArrow" onClick={incrementCarousel}>
                next
              </span>
            </div>
          )}
          {currentPageIndex === currentJacketPages.length - 1 && (
            <div className="carouselNext">
              <span
                className="carouselArrowInactive"
                onClick={incrementCarousel}
              >
                next
              </span>
            </div>
          )}
        </div>
      </div>
      <div
        className="classifyWrapper"
        style={{ visibility: showClassify ? "visible" : "hidden" }}
      >
        <ClassifyDeal
          key={dealjacket_id}
          dealjacket_id={dealjacket_id}
          toggleClassify={toggleClassify}
          handleClassify={handleClassify}
        />
      </div>
      <div
        className="editDealNameWrapper"
        style={{ visibility: showEditName ? "visible" : "hidden" }}
      >
        <EditDeal
          key={dealjacket_id}
          org_id={org_id}
          dealjacket_id={dealjacket_id}
          dealjacket_name={current_jacket.name}
          toggleEditName={toggleEditName}
          handleClassify={handleEditName}
          setJacketName={setJacketName}
        />
      </div>
      <div
        className="editDealNameWrapper"
        style={{ visibility: showAddonModal ? "visible" : "hidden" }}
      >
        <AddonManager
          key={dealjacket_id}
          org_id={org_id}
          dealjacket_id={dealjacket_id}
          toggleAddonModal={toggleAddonModal}
          jacketInfo={jacketInfo}
        />    
      </div>
      <div
        className="editDealNameWrapper"
        style={{ visibility: showScanModal ? "visible" : "hidden" }}
      >
        <ScanModal
          key={dealjacket_id}
          org_id={org_id}
          dealjacket_id={dealjacket_id}
          toggleScanModal={toggleScanModal}
          jacketInfo={jacketInfo}
        />    
      </div>      
    </div>
    )}
    </>
  );
}

function mapStateToProps(state) {
  const { dealjackets, authentication, alert } = state;
  return {
    authentication,
    dealjackets,
    alert
  };
}

const actionCreators = {
  classifyDealJacket: ingestionActions.classifyDealJacket,
  getDetail: dealjacketActions.getDetail,
};

const connectedViewAllPages = connect(
  mapStateToProps,
  actionCreators
)(ViewAllPages2);
export { connectedViewAllPages as ViewAllPages2 };
